const Banner = '/assets/jetsur/Jetsur-Website-Banner-Desktop.jpg';
// const HeaderLogo = '/assets/jetsur/jetsur-header-logo.png';
// const FooterLogo = '/assets/jetsur/jetsur-footer-logo-white.png';
const BookingInActive = '/assets/jetsur/Jetsur-Website-SearchBar-BuyATicket-Inactive.svg';
const BookingActive = '/assets/jetsur/Jetsur-Website-SearchBar-BuyATicket-Active.svg';
const CancelInActive = '/assets/jetsur/Jetsur-Website-SearchBar-CancelATicket-Inactive.svg';
const CancelActive = '/assets/jetsur/Jetsur-Website-SearchBar-CancelATicket-Active.svg';

const OriginIcon = '/assets/jetsur/Jetsur-Website-SearchBar-Origin.svg';
const DestinationIcon = '/assets/jetsur/Jetsur-Website-SearchBar-Destination.svg';
const pin = '/assets/jetsur/Jetsur-Website-SearchBar-pin.svg';
const CalendarIcon = '/assets/jetsur/Jetsur-Website-SearchBar-Calendar.svg';

const Whatsapp = '/assets/jetsur/whatsapp.svg';
const Email = '/assets/jetsur/Jetsur-Website-Contact-Email.svg';
const HeadPhone = '/assets/jetsur/Jetsur-Website-Contact-Phone.svg';
const YellowLine = '/assets/jetsur/Jetsur-Website-Line-Yellow.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/jetsur/Jetsur-Website-WhereToFindMyPNR.svg';

// const PopupIcon = '/assets/jetsur/Jetsur-Website-WhereToFindMyPNR.jpg';

// Icons Section
const ist = '/assets/jetsur/Jetsur-Website-TheCompany-Seats.svg';
const second = '/assets/jetsur/Jetsur-Website-TheCompany-Technology.svg';
const third = '/assets/jetsur/Jetsur-Website-TheCompany-PrintTicket.svg';
const close = '/assets/jetsur/close.svg';

const address = '/assets/jetsur/Jetsur-Website-Contact-Address.svg';


const success = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-CheckMark-Orange.svg';
const failure = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Information-Orange.svg';

const tick = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tick-Orange.svg';
const heartOn = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOn-Orange.svg';
const heartOff = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOff-Orange.svg';
const downArrow = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RightDocument-Orange.svg';
const userIcon = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Login-Orange.svg';
const trips = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyTrips-Orange.svg';
const cards = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyCards-Orange.svg';
const wallet = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const transaction = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ShareMoney-Orange.svg';
const otp = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RestorePassword-Orange.svg';

const jetsurIcons = [
  { icon: Banner, name: 'Banner' },

  // { icon: HeaderLogo, name: 'headerLogo' },
  { icon: address, name: 'address' },
  // { icon: FooterLogo, name: 'footerLogo' },

  { icon: downArrow, name: 'downArrow' },
  { icon: userIcon, name: 'userIcon' },
  { icon: trips, name: 'trips' },
  { icon: cards, name: 'cards' },
  { icon: wallet, name: 'wallet' },
  { icon: transaction, name: 'transaction' },
  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: tick, name: 'tick' },
  { icon: heartOn, name: 'heartOn' },
  { icon: heartOff, name: 'heartOff' },
  { icon: registrationSuccess, name: 'registrationSuccess' },
  { icon: otp, name: 'otp' },

  { icon: OriginIcon, name: 'Origin' },
  { icon: DestinationIcon, name: 'Destination' },
  { icon: pin, name: 'pin' },
  { icon: CalendarIcon, name: 'Calendar' },

  { icon: BookingInActive, name: 'BIA' },

  { icon: success, name: 'success' },
  { icon: failure, name: 'failure' },
  { icon: BookingActive, name: 'BA' },
  { icon: CancelInActive, name: 'CIA' },
  { icon: CancelActive, name: 'CA' },

  // { icon: PopupIcon, name: 'Popup' },

  { icon: Whatsapp, name: 'Whatsapp' },
  { icon: Email, name: 'Email' },
  { icon: HeadPhone, name: 'Headphone' },
  { icon: YellowLine, name: 'Line' },

  { icon: animation, name: 'animation' },
  { icon: checkboxIcon, name: 'Checkbox' },

  // Icons Section
  { icon: ist, name: 'ist' },
  { icon: second, name: 'second' },
  { icon: third, name: 'third' },
  { icon: pnr, name: 'pnr' },
  { icon: close, name: 'close' },
];

export default jetsurIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/jetsurIcons.js